import { Component, OnInit } from '@angular/core';
import { EMPTY, Observable } from 'rxjs';
import { AuthService } from './services/auth.service';
import { FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { User } from './interfaces/user';
import { map } from 'rxjs/operators';

declare var $: any;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.sass']
})
export class AppComponent implements OnInit{
  title = 'FENIX TRANSPORT';
  public isLogin: Observable<boolean>;
  public isSuperAdmin: Observable<boolean>;
  public userName: Observable<string> = EMPTY;
  public sendForm = this.fb.group({
    user: ['', Validators.required],
    password: ['', Validators.required]
  });
  public errors = null;

  constructor(
    private authService: AuthService,
    private fb: FormBuilder,
    private as: AuthService,
    private route: Router) { 
    this.isLogin = this.authService.isSignedInStream;
    this.isSuperAdmin = this.authService.user.pipe(map(a=>{
      if(a!=null && a.rol == "_SU") return true;
      return false;
    }));
    this.userName = this.authService.user.pipe(map<User|null, string>((us:(User|null))=>
     us?.name + " (" + us?.access + ")"))
  }

  ngOnInit(){}

  onSignInSubmit(e: any) {
    e.preventDefault();
    this.as.loginEmail(this.sendForm.get('user')?.value, this.sendForm
    .get('password')?.value).then(v => {
       this.closeLoginModal();
       this.route.navigate(['/']);
    }).catch(er => {
      this.errors = er;
    });
  }

  closeLoginModal(){
    $('#modalLogIn').modal('hide');
  }

  logOut(){
    this.as.logout();
  }

}
